import { render } from "./CreateGroupChat.vue?vue&type=template&id=7caf8b96&scoped=true"
import script from "./CreateGroupChat.vue?vue&type=script&lang=js"
export * from "./CreateGroupChat.vue?vue&type=script&lang=js"

import "./CreateGroupChat.vue?vue&type=style&index=0&id=7caf8b96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7caf8b96"]])

export default __exports__